import {environment} from "environments";

(() => {
  class TableController {
    constructor($scope, $state, $location, localStorageService) {
      'ngInject';

      Object.assign(this, {
        $location,
        $scope,
        $state,
        localStorageService,
        BOD_2143: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BOD_1837: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BOD_1847: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        BOD_2805: ['localhost', 'dev', 'qa', 'staging', 'production'].includes(environment.constants.ENV),
        availableLimits: [10, 20, 50, 75, 100],
        saveOnChange: false,
      });
    }

    $onInit() {
      if (!this.pagination) {
        throw new Error('Table requires a pagination object');
      }

      if (_.isEmpty(this.pagination)) {
        this.pagination = {
          limit: 20,
          offset: 0
        };
      }

      if(!this.BOD_2805) {
        this.availableLimits = [10, 20, 50, 75, 100]
      }

      const cache = this.localStorageService.get(this.savePageLocalStorageKey);
      if (cache?.saveOnChange) {
        this.saveOnChange = cache.saveOnChange;
        this.pagination = cache;
      }
      if (this.pagination.offset > this.pagination.total) {
        this.pagination.total = 9999;
      }
      this.$scope.$watch('$ctrl.pagination.total', (current, old) => {
        this.setCurrentPage();
      });
      this.$scope.$watch('$ctrl.pagination.limit', this.onLimitChanged.bind(this));
      this.$scope.$watch('$ctrl.currentPage', this.onPaginationChange.bind(this));
      this.setCurrentPage();
    }

    get pages() {
      return _.range(0, this.totalPages);
    }

    get totalPages() {
      return Math.ceil(this.pagination.total / this.pagination.limit);
    }

    get hasNextPage() {
      return this.currentPage * this.pagination.limit < this.pagination.total;
    }

    get hasPreviousPage() {
      return this.currentPage > 1;
    }

    goNext() {
      this.pagination.offset += this.pagination.limit;
      this.changePage();
    }

    goPrevious() {
      this.pagination.offset -= this.pagination.limit;

      if (this.pagination.offset < 0) {
        this.pagination.offset = 0;
      }

      this.changePage();
    }

    changePage() {
      this.setCurrentPage();
      this.onPageChange();
    }

    setCurrentPage() {
      let {
        limit,
        offset,
        total
      } = this.pagination;

      if (offset > total) {
        offset = total - limit;
      } else {
        offset = offset < 0 ? 0 : offset;
      }

      if (limit > total) {
        this.pagination.total = 9999;
      } else {
        this.currentPage = Math.ceil(offset > 0 ? offset / limit + 1 : 1);
      }
      if (this.saveOnChange) {
        this.setPaginationCache();
      }
    }

    onLimitChanged(newLimit, oldLimit) {
      if (newLimit === oldLimit) {
        return;
      }

      if (this.pagination.limit > this.pagination.total) {
        this.pagination.offset = 0;
      }

      this.pagination.limit = newLimit;
      this.pagination.offset = (this.currentPage * newLimit) - newLimit;

      this.changePage();
    }

    onPaginationChange(newPage, oldPage) {
      if (!newPage || newPage === oldPage) {
        return;
      }

      this.pagination.offset = this.pagination.limit * newPage - this.pagination.limit;
      this.changePage();
      this.onPageChange();
    }

    _isZero(number) {
      return parseInt(number, 10) === 0;
    }

    onSaveOnChangeChange() {
      this.setPaginationCache();
    }

    setPaginationCache() {
      this.localStorageService.set(this.savePageLocalStorageKey, {
        ...this.pagination,
        saveOnChange: this.saveOnChange
      });
    }

  }

  TableController.$inject = ["$scope", "$state", "$location", "localStorageService"];
  angular.module('pims').component('kjTable', {
    transclude: true,
    templateUrl: 'app/components/table/table.html',
    controller: TableController,
    bindings: {
      savePageLocalStorageKey: '=',
      pagination: '=',
      sortBy: '=',
      sortOrder: '=',
      onPageChange: '&',
      onSort: '&',
      striped: '<',
      hideRow: '<?',
      availableLimits: '<?',
    }
  }).directive('kjTableHeader', () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: `
          <div class="thead">
            <div class="tr" ng-transclude></div>
          </div>
        `
    };
  }).directive('kjTableColumn', ["$timeout", $timeout => {
    'ngInject';

    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      require: '^^kjTable',
      scope: {
        sortable: '=?'
      },
      template: `
          <div class="th" ng-click="sort()">
            <span ng-transclude></span>
            <i ng-if="sortable && showSort" class="ion-chevron-{{ sortDirection }}">
          </div>
        `,

      link(scope, element, attrs, tableCtrl) {
        if (scope.sortable) {
          setArrow();
        }

        function setArrow() {
          scope.showSort = tableCtrl.sortBy === scope.sortable;
          scope.sortDirection = tableCtrl.sortOrder === 'asc' ? 'up' : 'down';
        }

        scope.$watch(() => {
          return tableCtrl.sortBy;
        }, setArrow);

        scope.sort = () => {
          if (!scope.sortable) {
            return;
          } // clicking already actively sorted column, change direction


          if (tableCtrl.sortBy === scope.sortable) {
            tableCtrl.sortOrder = tableCtrl.sortOrder === 'asc' ? 'desc' : 'asc';
          } else {
            tableCtrl.sortBy = scope.sortable;
          }

          $timeout(() => {
            setArrow();
            tableCtrl.onSort();
          });
        };
      }

    };
  }]).directive('kjTableBody', () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: '<div class="tbody" ng-transclude></div>'
    };
  }).directive('kjTableRow', () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: '<a class="tr no-transition" ng-transclude></a>'
    };
  }).directive('kjTableRowNoLink', () => {
    return {
      restrict: 'E',
      replace: true,
      transclude: true,
      template: '<div class="tr no-transition" ng-transclude></div>'
    };
  }).directive('kjTableCell', () => {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      transclude: true,
      template: '<div class="td" ng-transclude></div>'
    };
  }).directive('kjTableCellLink', () => {
    return {
      restrict: 'E',
      replace: true,
      scope: true,
      transclude: true,
      template: '<a class="td" ng-transclude></a>'
    };
  });
})();
